var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_sposta",
    "data-name": "icona sposta",
    transform: "translate(-503 -17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_sposta-2",
    "data-name": "icona sposta",
    transform: "translate(505 17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_121",
    "data-name": "Raggruppa 121"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_1",
    "data-name": "Linea 1",
    x2: 15,
    transform: "translate(0 9.5)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow_su",
    "data-name": "arrow su",
    d: "M9,20.5l7-7,7,7Z",
    transform: "translate(-8.5 -13.5)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow_giu",
    "data-name": "arrow giu",
    d: "M9,13.5l7,7,7-7Z",
    transform: "translate(-8.5 -1.5)",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.51a707474fc76d5ff346cfd85e05ce44.svg";
export { ForwardRef as ReactComponent };